import { render, staticRenderFns } from "./GlobalSettingDashboard.vue?vue&type=template&id=626fdea5&scoped=true"
import script from "./GlobalSettingDashboard.vue?vue&type=script&lang=js"
export * from "./GlobalSettingDashboard.vue?vue&type=script&lang=js"
import style0 from "./GlobalSettingDashboard.vue?vue&type=style&index=0&id=626fdea5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626fdea5",
  null
  
)

export default component.exports